import { Modal } from 'antd';
import { USER_UUID } from './constants';
import { translate } from '../l10n/translate';

let shown = false;

/**
 * Aviso de clave API Cloud inválida o ausente. Fuerza la salida a la pantalla de
 * gestión de la clave.
 */
export function showCloudTokenModal({ title, message } = {}) {
  if (shown) return;
  shown = true;

  const userUuid = localStorage.getItem(USER_UUID);

  Modal.confirm({
    title: title ?? translate('Clave API Cloud no válida'),
    content: message ?? translate('Revise su clave API Cloud para poder usar el traductor de librerías.'),
    okText: translate('Revisar clave'),
    cancelButtonProps: { style: { display: 'none' } },
    keyboard: false,
    onOk: () => { shown = false; window.location.href = `/users/cloudapikey/${userUuid}`; },
  });
}
